import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';

import { getShopTimezone } from '../shops/selectors';
import * as reservationSelectors from '../reservation/selectors';


const WithTimezone = compose(
  withRouter,
  connect(
    (state, ownProps) => ({
      timezone: getShopTimezone(state, ownProps.params.shopRoute) || reservationSelectors.getShopTimezone(state),
    })
  )
);

export default WithTimezone;



// WEBPACK FOOTER //
// ./src/app/hoc/WithTimezone.js